import { z } from 'zod';
import { MaybeNil } from './interfaces';
import { DESCRIPTION_MAX_LENGTH } from '../config/constants';

interface IDuplicateArgs {
  name: string;
  entitiesList: Array<{ name: MaybeNil<string> }>;
  snapshotName?: string;
}

export const isDuplicate = ({
  name,
  entitiesList,
  snapshotName,
}: IDuplicateArgs): boolean => {
  if (!name) {
    return false;
  }

  const value = name.trim().toLowerCase();

  // in case of edit operation, unchanged value should not cause dup name error
  if (snapshotName?.toLowerCase() === value) {
    return false;
  }

  if (!entitiesList?.length) {
    return false;
  }

  return entitiesList.some((entity) => entity?.name?.toLowerCase() === value);
};

export const descriptionFieldSchema = z
  .string()
  .trim()
  .max(DESCRIPTION_MAX_LENGTH)
  .optional();

export const nameFieldSchema = (maxLength: number, duplicate?: boolean) =>
  z
    .string()
    .trim()
    .min(1) // do not allow empty strings
    .max(maxLength)
    .superRefine((val, ctx) => {
      if (duplicate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Name is duplicate',
          fatal: true,
        });

        return z.NEVER;
      }
    });
